var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 20.292969 5.2929688 L 9 16.585938 L 4.7070312 12.292969 L 3.2929688 13.707031 L 9 19.414062 L 21.707031 6.7070312 L 20.292969 5.2929688 z"}));
}

CheckInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
